(ns ui.view.survey.modals.sub
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::remove-modal-open?
 (fn [db [_]]
   (get db ::remove-modal-open?)))

(rf/reg-sub
 ::submit-modal-open?
 (fn [db [_]]
   (get db ::submit-modal-open?)))

(rf/reg-sub
 ::show-resolve-errors-warning?
 (fn [db [_]]
   (get db ::show-resolve-errors-warning?)))

(rf/reg-sub
 ::show-rows-without-errors?
 (fn [db [_]]
   (get db ::show-rows-without-errors?)))

(rf/reg-sub
 ::show-columns-without-errors?
 (fn [db [_]]
   (get db ::show-columns-without-errors?)))

(rf/reg-sub
 ::show-error-popover?
 (fn [db [_]]
   (get db ::show-error-popover?)))

(rf/reg-sub
 ::num-fmt-modal-open?
 (fn [db _]
   (get db ::num-fmt-modal-open?)))

(rf/reg-sub
 ::missing-modal-open?
 (fn [db _]
   (get db ::missing-modal-open?)))

(rf/reg-sub
 ::survey-id
 (fn [db [_]]
   (get db ::survey-id)))

(rf/reg-sub
 ::save-num-format-in-ls
 (fn [db _]
   (get db ::save-num-format-in-ls)))

(rf/reg-sub
 ::deleting-column?
 (fn [db [_]]
   (get db ::deleting-column?)))
